import React from 'react';
import { Placeholder, VisitorIdentification, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { loadReCaptcha } from 'react-recaptcha-v3'
import ObjBackToTop from './components/AllPages/ObjBackToTop'; 
import MetaSitecore from  './components/AllPages/MainMeta'; 
import { withTranslation } from 'react-i18next';
import { isAppMobile } from "./utilities/FrontFunctions/AoxFrontFunctions"

// CSS
import './assets/css/index.css'
import { setStyleColors } from './assets/css/colors'
import { setStyleFonts } from './assets/css/fonts'
import { templatePageWithoutCookies } from './data/const';

class Layout extends React.Component { 
    state = {
        hydrated: false
    };

    componentDidMount() {
		// recaptcha v3
		loadReCaptcha(this.props.t('recaptcha_sitekey'));

        setStyleColors();
        setStyleFonts();

        this.setState({ hydrated: true });
	}

    isNotTemplatewithoutCookies = (templateId) => {
        return templateId.toUpperCase() !== templatePageWithoutCookies.toUpperCase()
    }
  
    render() { 
        const { hydrated } = this.state;
        const mobileApp = isAppMobile();

        return (
            <React.Fragment>
            
                {this.isNotTemplatewithoutCookies(this.props.route?.templateId) && <MetaSitecore />}
                <VisitorIdentification />
            
                <Placeholder name="main_header" rendering={this.props.route} /> 

                <ObjBackToTop />
                
                <main className={`main_container ${isAppMobile() ? "mobileApp" : "" }`}>
                    <Placeholder name="main_container" rendering={this.props.route} />
                </main>

                {hydrated && !mobileApp && (
                    <Placeholder name="main_footer" rendering={this.props.route} /> 
                )}

            </React.Fragment>
        )
    }
};

//export default Layout;
export default withTranslation()((withSitecoreContext()(Layout)));
